<template>
  <v-row no-gutters>
    <v-col class="py-1 pr-4" style="min-width: 0">
      <div style="display: flex; align-items: center">
        <span
          style="
            font-family: Inter;
            font-size: 0.875rem;
            font-weight: 400;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
          "
        >
          {{ alert?.url || url }}
        </span>
      </div>
    </v-col>
    <v-col cols="auto" class="py-1" style="flex-shrink: 0">
      <span
        :style="{
          color: statusColor,
          fontFamily: 'Inter',
          fontSize: '0.875rem',
          fontWeight: '600',
          whiteSpace: 'nowrap',
        }"
      >
        {{ connectsValue }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    alert: {
      type: Object,
      default: null,
    },
    status: {
      type: String,
      required: true,
    },
    node: {
      type: Object,
      default() {
        return {};
      },
    },
    url: {
      type: String,
      default: '',
    },
  },
  computed: {
    connectsValue() {
      if (this.alert) {
        let value = this.$store.state.metrics.metric[this.alert.id];
        if (value == '1') {
          return 'Available';
        } else {
          return 'Unavailable';
        }
      } else {
        return 'Advertised';
      }
    },
    statusColor() {
      switch (this.connectsValue) {
        case 'Available':
          return '#4CAF50';
        case 'Unavailable':
          return '#FF5252';
        case 'Advertised':
          return '#9E9E9E';
        default:
          return '#9E9E9E';
      }
    },
  },
};
</script>

<style></style>
